import { Action, State, StateContext } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { SubscriptionApiService } from '../../_services/subscription-service/api/subscription-api-service.service';
import {
  ClearSubscriptionState,
  SetSubscriptionStateFromReloadAppState,
  SetSubscriptionStateFromUserLogin,
  SetSubscriptionStateUpgradeSubscription,
} from './subscription.actions';
import { SubscriptionStateModel } from './subscription.models';

@State<SubscriptionStateModel>({
  name: 'subscription',
  defaults: {
    hasAccounting: undefined,
    hasSubscriptionCards: true,
    isActive: false,
    hasCurrentSubscriptionData: false,
  },
})
@Injectable()
export class SubscriptionState {
  readonly subscriptionApiService = inject(SubscriptionApiService);

  @Action([
    SetSubscriptionStateFromUserLogin,
    SetSubscriptionStateFromReloadAppState,
    SetSubscriptionStateUpgradeSubscription,
  ])
  setSubscriptionState({ patchState }: StateContext<SubscriptionStateModel>) {
    return this.subscriptionApiService.getCurrentSubscription().pipe(
      tap((data) => {
        if (data) {
          patchState({
            hasAccounting: data?.package.has_accounting,
            isActive: data?.package.is_active,
            hasSubscriptionCards: data?.package.has_subscription_cards,
            hasCurrentSubscriptionData: Boolean(data),
          });
        } else {
          patchState({
            hasCurrentSubscriptionData: false,
          });
        }
      }),
    );
  }

  @Action(ClearSubscriptionState)
  clearSubscriptionState({ setState }: StateContext<SubscriptionStateModel>) {
    setState({ hasAccounting: true, hasSubscriptionCards: true, isActive: false, hasCurrentSubscriptionData: false });
  }
}
